/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import { useForm } from 'antd/lib/form/Form';
import ListPrivacy from '../Shared/ListPrivacy';
import DocTabs from './component/DocTabs';
import { usePreviewtoString } from './component/PreviewToString';
import { PlusOutlined } from '@ant-design/icons';
import RecruitmentPolicyService from '../../../services/RecruitmentPolicy.service';
import GlobalService from '../../../services/Global.service';
import { calculateImageWidth } from '../../../util/util';
import usePermission from '../../../hooks/usePermission';

export default function RecruitmentPolicy({ selectType }) {
    const { t, i18n } = useTranslation(['translation', 'hr-policy']);
    let lang = i18n.language;
    const [data, setData] = useState([]);
    const [currentSelectList, setCurrentSelectList] = useState();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState();
    const [detailPublished, setDetailPublished] = useState();

    let navigate = useNavigate();
    // Logo
    const [logo, setLogo] = useState('');
    const [logoPublish, setLogoPublish] = useState('');
    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImage(companyLogoId);
            if (data.resultData?.imageId) {
                return `data:image/png;base64,${data.resultData?.imageId}`;
            }
        } catch (error) {
            setLogo('');
            setLogoPublish('');
            console.log(error);
        }
    };

    const getPolicyList = async () => {
        const { data } = await RecruitmentPolicyService.searchRecruitmentPolicy(
            selectType ? selectType : ''
        );
        if (data?.resultData) {
            setData(data.resultData);
            setCurrentSelectList(data.resultData[0]);
        }
    };

    const getRecruitmentPolicyDetail = async () => {
        try {
            const { data } =
                await RecruitmentPolicyService.getRecruitmentPolicyDetail(
                    currentSelectList?.recruitmentPrivacyPolicyNoticeId
                );
            if (data?.resultData) {
                setDetail(data?.resultData);
                setLoading(false);
                // Logo
                setLogo('');
                if (
                    data?.resultData?.recruitmentPrivacyPolicy
                        ?.recruitmentCompanyLogoId
                ) {
                    getImage(
                        data?.resultData?.recruitmentPrivacyPolicy
                            ?.recruitmentCompanyLogoId
                    ).then((logo) => setLogo(logo));
                }
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const getPublishedVersion = async () => {
        try {
            const { data } = await RecruitmentPolicyService.getPublishedVersion(
                currentSelectList?.recruitmentPrivacyPolicyNoticeId
            );
            if (data?.resultData) {
                const parse = JSON.parse(data?.resultData?.data);
                setDetailPublished(parse);
                setLogoPublish('');
                if (parse?.recruitmentPrivacyPolicy?.recruitmentCompanyLogoId) {
                    getImage(
                        parse?.recruitmentPrivacyPolicy
                            ?.recruitmentCompanyLogoId
                    ).then((logo) => setLogoPublish(logo));
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getPolicyList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectType]);

    useEffect(() => {
        if (currentSelectList?.recruitmentPrivacyPolicyNoticeId)
            getRecruitmentPolicyDetail();
        if (
            currentSelectList?.hasChanged &&
            currentSelectList?.status === 'Published'
        )
            getPublishedVersion();
        else setDetailPublished();
    }, [currentSelectList?.recruitmentPrivacyPolicyNoticeId]);

    const notify = useNotify();
    const [form] = useForm();

    const handelRename = (values) => {
        setLoading(true);
        if (currentSelectList?.recruitmentPrivacyPolicyNoticeId) {
            const payload = {
                recruitmentPrivacyPolicyId:
                    currentSelectList?.recruitmentPrivacyPolicyNoticeId,
                nameEn: values.nameEn,
                nameTh: values.nameTh,
            };
            setTimeout(async () => {
                try {
                    const { data } = await RecruitmentPolicyService.rename(
                        payload
                    );
                    if (data.resultCode === 1) {
                        form.resetFields();
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully saved data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            setLoading(false);
                            getPolicyList();
                            getRecruitmentPolicyDetail();
                        }, 1300);
                    } else {
                        setLoading(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to rename'),
                        });
                    }
                } catch (error) {
                    setLoading(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to rename'),
                    });
                }
            }, 1000);
        }
    };

    const width1 = calculateImageWidth(logo);
    const width2 = calculateImageWidth(logoPublish);
    const { html } = usePreviewtoString(detail, 'TH', logo, width1);
    const { html: htmlEn } = usePreviewtoString(detail, 'EN', logo, width1);

    const { html: htmlPublish } = usePreviewtoString(
        detailPublished,
        'TH',
        logoPublish,
        width2
    );
    const { html: htmlPublishEn } = usePreviewtoString(
        detailPublished,
        'EN',
        logoPublish,
        width2
    );

    const { isAuditor } = usePermission();

    return (
        <Layout>
            <div className="flex items-center my-4">
                <div className="flex-1 font-bold text-xl">
                    {t('Recruitment Privacy Policy list', {
                        ns: 'hr-policy',
                    })}
                </div>
                <Button
                    disabled={isAuditor}
                    type="primary"
                    size="large"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.RECRUITMENT_PRIVACY}/new#step1`
                        );
                    }}
                    icon={<PlusOutlined />}
                >
                    {t('Add Policy')}
                </Button>
            </div>
            {true ? (
                <div className="grid grid-cols-7 gap-4">
                    <ListPrivacy
                        data={data}
                        pathEdit={ROUTER.POLICY.RECRUITMENT_PRIVACY}
                        stepEdit={'#step9'} // step preview
                        currentSelectName={{
                            nameTh: detail?.recruitmentPrivacyPolicy
                                ?.recruitmentPrivacyPolicyNameTh,
                            nameEn: detail?.recruitmentPrivacyPolicy
                                ?.recruitmentPrivacyPolicyNameEn,
                            namePublishTh:
                                detailPublished?.recruitmentPrivacyPolicy
                                    ?.recruitmentPrivacyPolicyNameTh,
                            namePublishEn:
                                detailPublished?.recruitmentPrivacyPolicy
                                    ?.recruitmentPrivacyPolicyNameEn,
                            placeholderNameEN: t(
                                'PlaceholderRecruitmentNameEN',
                                {
                                    ns: 'hr-policy',
                                }
                            ),
                            placeholderNameTH: t(
                                'PlaceholderRecruitmentNameTH',
                                {
                                    ns: 'hr-policy',
                                }
                            ),
                        }}
                        setCurrentSelectList={setCurrentSelectList}
                        currentSelectList={currentSelectList}
                        form={form}
                        // Parameters Name
                        policyObject={{
                            privacyName:
                                lang === 'en'
                                    ? 'recruitmentPrivacyPolicyNoticeNameEn'
                                    : 'recruitmentPrivacyPolicyNoticeNameTh',
                            nameTh: 'recruitmentPrivacyPolicyNoticeNameTh',
                            nameEn: 'recruitmentPrivacyPolicyNoticeNameEn',
                            privacyType:
                                lang === 'en'
                                    ? 'recruitmentPrivacyPolicyTypeEn'
                                    : 'recruitmentPrivacyPolicyTypeTh',
                            privacyId: 'recruitmentPrivacyPolicyNoticeId',
                            privacyCompany:
                                lang === 'en'
                                    ? 'recruitmentCompanyNameEn'
                                    : 'recruitmentCompanyNameTh',
                        }}
                        handelRename={(value) => handelRename(value)}
                        loading={loading}
                        linkName="external-recruitment-privacy"
                        getPolicyList={getPolicyList}
                        historyObject={{
                            type: 'recruitment',
                            serviceHistory:
                                RecruitmentPolicyService.getHistories,
                            historyParamName: 'recruitmentPrivacyPolicyId', // ชื่อ payload ของ id ที่ service get history เช่น recruitmentPrivacyPolicyId: "1234" ที่ต้องใส่คือ: recruitmentPrivacyPolicyId
                            historyResultIdName:
                                'recruitmentPrivacyPolicyHistoryId', // ได้หลังจาก service get history ใน result ชื่อ parameter ของ id เช่น { "recruitmentPrivacyPolicyHistoryId" : 1234 } ที่ต้องใส่คือ: recruitmentPrivacyPolicyHistoryId
                        }}
                        // pop up ของ confirm ก่อน delete
                        confirmObject={{
                            title:
                                lang === 'en'
                                    ? 'There may be websites that use this recruitment privacy policy.'
                                    : 'อาจมีเว็บไซต์ใช้นโยบายความเป็นส่วนตัว \nด้านการสรรหาและคัดเลือกบุคลากรนี้อยู่',
                            text:
                                lang === 'en'
                                    ? `Before deleting the data, please check that no website is using this recruitment privacy policy.`
                                    : `ก่อนลบข้อมูล โปรดตรวจสอบว่าไม่มีเว็บไซต์ใดใช้นโยบาย \nความเป็นส่วนตัวด้านการสรรหาและคัดเลือกบุคลากรนี้`,
                        }}
                        // pop up ของ delete
                        deleteObject={{
                            serviceDelete:
                                RecruitmentPolicyService.deleteRecruitmentPolicy,
                            title:
                                currentSelectList?.status === 'Draft'
                                    ? t('ModalTitleDeleteDraft', {
                                          ns: 'hr-policy',
                                      })
                                    : t('ModalTitleDeleteDraft', {
                                          ns: 'hr-policy',
                                      }),
                            text:
                                currentSelectList?.status === 'Draft'
                                    ? `${t('ModalDeleteDraft', {
                                          version: currentSelectList?.version,
                                          ns: 'hr-policy',
                                      })}`
                                    : `${t(
                                          'ModalDetailDeletePublishRecruitment',
                                          {
                                              ns: 'hr-policy',
                                          }
                                      )} \n${t('ModalDeletePublish', {
                                          version:
                                              currentSelectList?.latestPublishVersion,
                                          ns: 'hr-policy',
                                      })}`,
                        }}
                        templateBody={{
                            html,
                            htmlEn,
                            htmlPublish,
                            htmlPublishEn,
                        }}
                    >
                        {(previewLang) => (
                            <DocTabs
                                logo={logo}
                                logoPublish={logoPublish}
                                currentSelectList={currentSelectList}
                                previewLang={previewLang}
                                privacyPolicyNoticeId={
                                    currentSelectList?.recruitmentPrivacyPolicyNoticeId
                                }
                                detail={detail}
                                loading={loading}
                                detailPublished={detailPublished}
                            />
                        )}
                    </ListPrivacy>
                </div>
            ) : (
                <div className="grid items-center justify-center mt-20">
                    <IconEmpty />
                </div>
            )}
        </Layout>
    );
}
